module.exports = __webpack_public_path__ + "img/idea-leader-4.cb2f1fb7.svg";